document.addEventListener('DOMContentLoaded', function() {
  let lastScrollTop = 0;
  const header = document.querySelector('.site-header');
  
  if (!header) return; // exit if header not found

  // initially show header
  header.classList.add('show');

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop && scrollTop > 100) {
      // scrolling down and passed 50px
      header.classList.add('hide');
      header.classList.remove('show');
    } else {
      // scrolling up
      header.classList.add('show');
      header.classList.remove('hide');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; 
  });
});
